import React from "react";
import Arrow from "/fallbacks/arrow-new.svg";
const Button = ({ text, type, handleClick, loading, processingLabel, margin }) => {
  const buttonTheme = window.post_template.checkout_v4_global_components?.checkout_v4_components_btnTheme;

  return (
    <button
      data-testid="cc-complete-order"
      style={{ marginTop: margin && margin + "px" }}
      className="button button--submit"
      id="hook-form"
      type={type}
      theme={buttonTheme}
      onClick={handleClick}
      loading={`${String(loading)}`}
    >
      <span className="processing">{processingLabel}</span>
      <span className="cta__loading"></span>
      <span className="submit__text">{text}</span>
      {/* <div className="submit__icon--wrapper" style={{ backgroundImage: `url('${Arrow}')` }}>
				<span
					className="submit__icon"
					style={{ maskImage: `url('${Arrow}')`, WebkitMaskImage: `url('${Arrow}')`, background: '#ffffff' }}
				></span>
			</div> */}
    </button>
  );
};

export default Button;
